import React, { useState, useEffect } from "react";
import { useForm, ValidationError } from "@formspree/react";

const ContactForm = () => {
  const [state, handleSubmit] = useForm("mpwpzwvd");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (state.succeeded) {
      setFormData({ name: "", email: "", message: "" });
    }
  }, [state.succeeded]);

  return (
    <section id="contact" className="mb-10">
      <h2 className="text-2xl font-bold mb-6 text-dark">Contacto</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {state.succeeded && (
          <p className="text-brown2 text-sm">¡Mensaje enviado!</p>
        )}

        <div>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full p-3 bg-bg2 border border-dark/20 focus:border-accent focus:outline-none text-dark text-sm"
            placeholder="Nombre"
            required
          />
        </div>

        <div>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full p-3 bg-bg2 border border-dark/20 focus:border-accent focus:outline-none text-dark text-sm"
            placeholder="Email"
            required
          />
          <ValidationError prefix="Email" field="email" errors={state.errors} />
        </div>

        <div>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="w-full p-3 bg-bg2 border border-dark/20 focus:border-accent focus:outline-none text-dark text-sm"
            placeholder="Mensaje"
            rows={4}
            required
          ></textarea>
        </div>

        <button
          type="submit"
          disabled={state.submitting}
          className="w-full py-3 bg-accent text-white text-sm font-medium hover:opacity-80 transition"
        >
          Enviar
        </button>
      </form>
    </section>
  );
};

export default ContactForm;
